import { DependencyList, EffectCallback, useEffect } from "react";
import { useIsFirstRender } from "./use-is-first-render";

/**
 * Вызывает useEffect только при обновлении зависимостей, игнорируя фазу монтирования компонента
 */
export const useUpdateEffect = (
  effect: EffectCallback,
  dependencies?: DependencyList
) => {
  const isFirstRender = useIsFirstRender();

  useEffect(() => {
    if (!isFirstRender) {
      return effect();
    }
  }, dependencies);
};
